import * as vipLifeCycle from '../services/vipLifeCycle';

export default {
  namespace: 'vipLifeCycle',
  state: {},
  effects: {
    *getLifeCycleList({ payload: { values } }, { call, put }) {
      const response = yield call(vipLifeCycle.getLifeCycleList, values);
      yield put({
        type: 'save',
        payload: {
          vipLifeCycleList: response.data.data,
          total: response.data.total,
        },
      });
    },
    *terminate({ payload: { values }, callback }, { call }) {
      const response = yield call(vipLifeCycle.terminate, values);
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
  },

  reducers: {
    save(state, action) {
      return { ...state, ...action.payload };
    },
  },
};
